import React from 'react';
import { DragSource } from 'react-dnd';
import OrderShipmentProduct from './OrderShipmentProduct';

const cardSource = {
  beginDrag(props) {
    return props.product;
  },
};

export const DndProduct = ({
  isDragging,
  isDropped,
  connectDragSource,
  product,
  productConfiguration,
  order,
  loadOrder
}) => {

  return connectDragSource(
    <div className="shipment-line-item" >
      <OrderShipmentProduct
        lineItem={product}
        productConfiguration={productConfiguration}
        enabledAddCustomerApproval={false}
        enabledNewTask={false}
        order={order}
        loadOrder={loadOrder}
      />
    </div>
  );
};

export default DragSource(
  'dndShipmentProducts',
  cardSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(DndProduct);
